import type { PlayerIndex } from '@tpubg/shared';

export interface PlayerStyle {
  label: string;
  name: string;
  symbol: string;
  main: string;
  light: string;
  dark: string;
  glow: string;
}

/** Colors are always paired with a label and a distinct emblem (● vs ◆). */
export const PLAYER_STYLES: Record<PlayerIndex, PlayerStyle> = {
  0: { label: 'P1', name: 'Blue', symbol: '●', main: '#2F8BFF', light: '#8CC6FF', dark: '#164787', glow: 'rgba(47,139,255,0.35)' },
  1: { label: 'P2', name: 'Orange', symbol: '◆', main: '#FF8A1F', light: '#FFC285', dark: '#8A4410', glow: 'rgba(255,138,31,0.35)' },
};

const BASE_LABELS = ['P1', 'P2'] as const;
/** Label for a computer-controlled player. */
export const BOT_LABEL = 'Bot';

/**
 * In vs-computer games the computer's seat is called "Bot" everywhere
 * (scoreboards, in-game tags, messages). Pass null to restore P1/P2.
 */
export function setCpuLabels(cpuPlayer: PlayerIndex | null): void {
  for (const i of [0, 1] as const) PLAYER_STYLES[i].label = i === cpuPlayer ? BOT_LABEL : BASE_LABELS[i];
}
